/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { GENERIC_PROJECT_HORIZONTAL_NAV } from '@jira/navigation-apps__horizontal-nav-selector/src/constants.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskAccessRedirectRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskAccessRedirectRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { LazyPeopleSettings, peopleAccessRedirect } from './ui/people/index.tsx';
import { SERVICE_DESK_PRODUCT } from './ui/product-routes/common/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const projectSettingsServicedeskAccessRedirectRouteEntry: Route = createEntry(
	projectSettingsServicedeskAccessRedirectRoute,
	() => ({
		group: 'project-settings-servicedesk',
		isRedirect: true,
		// eslint-disable-next-line no-restricted-syntax
		component: peopleAccessRedirect(`/jira/${SERVICE_DESK_PRODUCT}`),
		layout: serviceProjectLayout,
		navigation: {
			horizontal: GENERIC_PROJECT_HORIZONTAL_NAV,
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyPeopleSettings],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
